import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { InicioCargaDescargaEADModelEdit } from "./nuevacarga";
import { FiltroCargaDescargaEADComponent } from "./filtro";

type Entity = models.CargaDescargaEADDto;
import { columnas } from "./columns";
const resource = resources.CargaDescargaEAD;

export interface State {
    filtro: models.FiltroCargaDescargaEAD;
}
const IniciarButton = kea.defaultProps(kea.Button, { children: "Iniciar carga", iconClass: fa("plus"), style: "info" });
export class CargaDescargaEADList extends React.PureComponent<{}, State> {
    constructor(props) {
        super(props);
        this.state = { filtro: { Limite:100, Status: models.StatusCargaDescarga.EnProceso } };
    }
    modalManager = kea.createModalManager();

    filtro = (state: State) => state.filtro;
    items = createSelectorRx(this.filtro, filtro => observeResource(resource.Consultar, filtro));
    onEdit = (x: Entity) => history.go(`./${x.IdRegistro}`);
    onRegresar = () => history.go('../');

    onCancelar = async (x: Entity) => {
        if (await kea.yesno("¿Seguro de cancelar la carga/descarga?")) {
            await resource.CancelarCargaDescarga(x.IdRegistro);
        }
    }
    onVer = async (x: Entity) => {
        history.go("./" + x.IdRegistro);
    }
    onIniciarCarga = async () => {
        const result = await this.modalManager.showModal(InicioCargaDescargaEADModelEdit, undefined, {} as models.InicioCargaDescargaEADModel);
        if (result.result) {
            const value = await result.value;
            const id = await resource.IniciarCargaDescarga(value);
            await kea.message("Se inició la carga/descarga", "", "success");
            history.go("./" + id);
        }
    }

    render() {
        const cols = columnas(this);
        const items = this.items(this.state);
        return (
            <div>
                <kea.Title titulo="Cargas/descargas de entrega a domicilio" onRegresar={this.onRegresar}>
                    <IniciarButton onClick={this.onIniciarCarga} />
                </kea.Title>

                <FiltroCargaDescargaEADComponent value={this.state.filtro} onChange={filtro => this.setState({ filtro })} />
                <kea.Grid2 columnas={cols} cookieKey={"CargaDescargaEADListCookieKey"} items={items} />

                {this.modalManager.component}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargasEAD/list/list.tsx